/**
 * Drop this into your <IntlProvider /> to support basic rich text formatting
 * in your translations.
 */
export const defaultRichTextElements = {
  b: (text: React.ReactNode[]) => <b>{text}</b>,
  strong: (text: React.ReactNode[]) => <strong>{text}</strong>,
  i: (text: React.ReactNode[]) => <i>{text}</i>,
  em: (text: React.ReactNode[]) => <em>{text}</em>,
  u: (text: React.ReactNode[]) => <u>{text}</u>,
  mark: (text: React.ReactNode[]) => <mark>{text}</mark>,
  br: () => <br />,
};
